<template>
  <load-progress :condition="!dataLoaded" label="Chargement des données"></load-progress>
  <!-- Affichage du tree view et des éditeurs selon l'objet sélectionné -->

  <div v-if="dataLoaded">
    <form @submit.prevent="save">
      <div :class="dialog ? 'p-15' : 'py-2'">
        <div>
          <v-radio-group v-model="loginMode" class="radio-group">
            <v-radio :label="modeConnexion1" :value="2"></v-radio>
            <password v-if="loginMode==2"
                    ref="PASSWORD"
                    :hideButton="true"
                    @valid="valid"
                    @closeDialog="closeDialog">
            </password>
            <v-radio :label="modeConnexion2" :value="1"></v-radio>
          </v-radio-group>
        </div>
        <div>
        </div>

        <div class="d-flex flex-row-reverse">
          <loader-button :disabled="!updatedAndValid"
                         :label="saveLabel"
                         class="ms-2"
                         type="submit">
          </loader-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { ConnectionParam, ConnectionParamModes, LoginParam } from '@/generated/classes/Session';
import {
  storeDelivery,
  storeEtablissement,
  storeNotif,
  storeObjetMetier,
  storeSession, storeSupport, storeTransaction,
  storeUser
} from '@/generated/stores';
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import { FwkButtons, FwkControls, RessourceFwkButton, RessourceFwkControl, } from '@/ressources/globalRessources';
import User from '@/generated/classes/User';
import Password from '@/framework/connection/components/Password.vue';
import { defineComponent } from "vue";
import {CiRouter} from "@/framework/base/helpers/NavHelper.ts";
import LoadProgress from "@/framework/base/components/LoadProgress.vue";

export default defineComponent({
  components: {
    LoadProgress,
    LoaderButton,
    Password
  },
  props: {
    extended: {
      type: Boolean
    },
    dialog: {
      type: Boolean
    },
    reset: {
      type: Boolean
    }
  },
  data() {
    return {
      selectedMode: ConnectionParamModes.NONE,
      initMode: ConnectionParamModes.NONE,
      modeConnexion1: RessourceFwkControl(FwkControls.MODE_CONNEXION_PASSWORD).label,
      modeConnexion2: RessourceFwkControl(FwkControls.MODE_CONNEXION_CODE_MAIL).label,
      modeConnexion3: RessourceFwkControl(FwkControls.MODE_CONNEXION_CODE_SMS).label,
      saveLabel: RessourceFwkButton(FwkButtons.ENREGISTRER).label,
      passwordValid: false
    };
  },
  computed: {
    dataLoaded (): boolean {
      const res = storeSession.connectedUser;
      if (res) {
        this.loginMode = this.dialog ? ConnectionParamModes.PASSWORD : this.user.connectionMode;
        this.initMode = this.dialog ? ConnectionParamModes.PASSWORD : this.user.connectionMode;
      }
      return res != null;
    },
    user(): User {
      const connectedUser = storeSession.connectedUser;
      if (connectedUser) {
        return storeUser.getUser(connectedUser.id);
      } else {
        return new User();
      }
    },
    hasPassword(): boolean {
      return this.user.hasPassword;
    },
    hasMobile(): boolean {
      if (this.user.numeroId) {
        return this.user.numeroId > 0;
      } else {
        return false;
      }
    },
    loginMode: {
      get(): number {
        return this.selectedMode;
      },
      set(value: number) {
        this.selectedMode = value;
        this.user.connectionMode = value;
      }
    },
    usePassword(): boolean {
      return this.loginMode == ConnectionParamModes.PASSWORD;
    },
    updatedAndValid(): boolean {
      return this.passwordValid || ((this.selectedMode != this.initMode) && (this.selectedMode != 2 || this.user.hasPassword));
    }
  },

  methods: {
    valid(res: boolean): void {
      this.passwordValid = res;
    },
    save(): void {
      const param: ConnectionParam = new ConnectionParam();
      param.mode = this.loginMode;
      storeSession.setConnectionMode(param).then(() => {
        if (this.selectedMode == ConnectionParamModes.PASSWORD) {
          // @ts-expect-error : generated method
          this.$refs.PASSWORD.save()
        }
        const param: LoginParam = new LoginParam();
        storeSession.resetToken(param).then(res => {
          this.user.connectionMode = this.selectedMode;
          this.initMode = this.selectedMode;
          this.$emit('closeDialog');
        })
      });
    },
    closeDialog(): void {
      this.$emit('closeDialog');
    }
  }
})

</script>

<style>
  .password div.v-messages {
    display: block !important;
  }
</style>
